import React from 'react';
import BusinessHeaderBare from "../parts/BusinessHeaderBare";
import ScrollToTopOnMount from "../website-utils/ScrollToTopOnMount";
import {metaDescriptions, metaTitles, title} from "../website-utils/meta";
import {Helmet} from "react-helmet";
import BusinessForgotPasswordForm from "../parts/BusinessForgotPasswordForm";


class BusinessForgotPasswordPage extends React.Component {
  componentDidMount() {

  }

  render() {
    return (
      <div className={'business login'}>
        <Helmet>
          {title('SingleShift - Business Forgot Password')}
          {metaTitles('SingleShift - Business Forgot Password')}
          {metaDescriptions('Log In Page')}
        </Helmet>
        <ScrollToTopOnMount/>
        <div className="container">
          <BusinessHeaderBare/>
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-6">
              <h2>Forgot Your Password?</h2>
            </div>
          </div>
          <div className="singleshift-form">
            <BusinessForgotPasswordForm/>
          </div>
        </div>
      </div>
    );
  }
}


export default BusinessForgotPasswordPage;



// WEBPACK FOOTER //
// ./src/pages/BusinessForgotPasswordPage.js